import { useContextSelector } from "use-context-selector";
import { cdnImg } from "../../Utils/cdnImage";
import GameSwiper from "./GameSwiper";
import AuthContext from "../../context/AuthContext";

const CasinoModal = () => {
  const setCasinoModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setCasinoModal;
  });
  return (
    <div className="modal">
      <div
        className="w-full bg-cover bg-no-repeat"
        style={{
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          width: "100%",
          height: "fit-content",
          position: "absolute",
          bottom: "0",
        }}
      >
        <div
          style={{
            height: "30px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              width: "100px",
            }}
          ></div>
          <div
            onClick={() => setCasinoModal(false)}
            style={{ width: "58px", right: "0" }}
          >
            <img
              style={{ height: "auto", maxWidth: "100%" }}
              alt="icon_close"
              src={cdnImg("/assets/images/icon_close.png")}
            />
          </div>
        </div>
        <div style={{ width: "100%" }} className="header w-full" />
        <div className="wrapper">
          <div
            style={{
              height: "235px",
              width: "100%",
              position: "relative",
              zIndex: "10",
            }}
          >
            <div
              id="app"
              style={{
                left: "50%",
                transform: "translate(-50%, 0px) scale(0.48)",
                position: "absolute",
                bottom: "0",
                transformOrigin: "center bottom",
                width: "750px",
                height: "490px",
              }}
            >
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  height: "100%",
                  overflow: "hidden",
                }}
                className="container"
              >
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    borderTop: "4px solid rgba(229,100,100,.5)",
                    borderBottom: "2px solid rgba(229,100,100,.5)",
                  }}
                  className="lobby"
                >
                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      flexDirection: "column",
                      flexShrink: "0",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "107px",
                      // height: "470px",
                      marginLeft: "-107px",
                      marginRight: "30px",
                      padding: "95px 0",
                      color: "#fff",
                      fontFamily: "Oxanium",
                      fontSize: "16px",
                      fontWeight: "600",
                      lineHeight: "normal",
                      transition: "margin-left .5s ease",
                    }}
                    className="menu menu--on"
                  />
                  <div
                    style={{
                      position: "fixed",
                      right: "0",
                      zIndex: "10",
                      width: "112px",
                      height: "100%",
                      background:
                        "linear-gradient(90deg,rgba(44,5,5,0) 19.12%,rgba(40,3,3,.48) 67.05%,#240201 118.82%)",
                      pointerEvents: "none",
                    }}
                    className="shadow"
                  />
                  <GameSwiper />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CasinoModal;
